import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChevronLeft"><Path fillRule="evenodd" clipRule="evenodd" d="M8.41436 12.0001L15.7073 4.70718L14.293 3.29297L5.58594 12.0001L14.293 20.7072L15.7073 19.293L8.41436 12.0001Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronLeft;
